import type { TeamRole } from "@vv/teams-frontend";
import { ACTION_ALLOWED_ROLES, type WorkflowAction } from "../domain/request.types";

/**
 * Mirrors the real backend's RoleCheckerService: Owner bypasses everything;
 * otherwise the acting user needs at least one of the roles the action
 * allows, scoped to the request's team.
 */
export function canPerformAction(
  action: WorkflowAction,
  isOwner: boolean,
  myTeamRoles: TeamRole[],
): boolean {
  if (isOwner) return true;
  const allowedRoles = ACTION_ALLOWED_ROLES[action];
  return myTeamRoles.some((role) => allowedRoles.includes(role));
}
